(() => {
  const root = document.getElementById('nl4-product-compare');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const tray = root.querySelector('[data-nl4-tray]');
  const dialog = root.querySelector('dialog');
  const tableHost = root.querySelector('[data-nl4-table]');
  const loading = root.querySelector('[data-nl4-loading]');
  const loadingLabel = loading.textContent;
  const notice = root.querySelector('[data-nl4-notice]');
  const labels = Object.fromEntries([...root.querySelector('template').content.querySelectorAll('[data-key]')].map(el => [el.dataset.key,el.textContent]));
  const key = 'nl4:compare:1';
  let selected = [];
  let records = [];
  let controller;
  let revision = 0;
  let opener;
  const element = (tag,text,className) => { const el = document.createElement(tag); if (text != null) el.textContent = text; if (className) el.className = className; return el; };
  const valid = values => Array.isArray(values) ? values.filter(p => p && typeof p.handle === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(p.handle) && typeof p.title === 'string').filter((p,i,a) => a.findIndex(q => q.handle === p.handle) === i).slice(0,3).map(p => ({handle:p.handle,title:p.title.slice(0,300)})) : [];
  try { selected = valid(JSON.parse(localStorage.getItem(key) || '[]')); } catch (_) {}
  const save = () => { try { localStorage.setItem(key,JSON.stringify(selected)); } catch (_) {} };
  const message = text => { notice.textContent = text; };
  const productURL = handle => {
    const url = new URL(`${root.dataset.root.replace(/\/$/,'')}/products/${encodeURIComponent(handle)}`,location.origin);
    if (root.dataset.preview) url.searchParams.set('preview_theme_id',root.dataset.preview);
    return url;
  };
  const syncButtons = () => {
    document.querySelectorAll('[data-nl4-compare-handle]').forEach(button => {
      const active = selected.some(p => p.handle === button.dataset.nl4CompareHandle);
      const label = active ? root.dataset.remove : root.dataset.add;
      button.disabled = false;
      button.setAttribute('aria-pressed',String(active));
      button.setAttribute('aria-label',`${label}: ${button.dataset.nl4CompareTitle}`);
      const text = button.querySelector('[data-nl4-compare-label]');
      if (text.textContent !== label) text.textContent = label;
      button.removeAttribute('data-nl4-compare-pending');
    });
  };
  const offset = () => {
    if (tray.hidden) return;
    let bottom = document.querySelector('#PBarNextFrame') ? 70 : 0;
    document.querySelectorAll('sticky-add-to-cart').forEach(bar => {
      const rect = bar.getBoundingClientRect();
      if (getComputedStyle(bar).visibility !== 'hidden' && rect.top < innerHeight - bottom && rect.bottom > 0 && rect.height > 0) bottom = Math.max(bottom,innerHeight - rect.top);
    });
    tray.style.setProperty('--nl4-compare-offset',`${Math.ceil(bottom)}px`);
  };
  const sync = () => {
    tray.hidden = !selected.length;
    root.querySelector('[data-nl4-count]').textContent = selected.length;
    root.querySelector('[data-nl4-open]').disabled = selected.length < 2;
    root.querySelector('[data-nl4-hint]').textContent = selected.length < 2 ? labels.choose : labels.ready;
    const list = root.querySelector('[data-nl4-selected]');
    list.replaceChildren(...selected.map(p => {
      const li = element('li');
      const button = element('button',null,'nl4-compare-chip');
      button.type = 'button'; button.dataset.nl4Remove = p.handle;
      button.setAttribute('aria-label',`${root.dataset.remove}: ${p.title}`);
      button.title = p.title;
      button.append(element('span',p.title),element('b','×'));
      button.lastElementChild.setAttribute('aria-hidden','true');
      li.append(button); return li;
    }));
    syncButtons(); offset();
  };
  const close = () => { revision++; controller?.abort(); if (dialog.open) dialog.close(); };
  const returnFocus = () => {
    const usable = el => el?.isConnected && !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
    const candidates = [opener,root.querySelector('[data-nl4-selected] button'),...document.querySelectorAll('[data-nl4-compare-handle]')];
    candidates.find(usable)?.focus();
  };
  dialog.addEventListener('close',returnFocus);
  dialog.addEventListener('cancel',() => { revision++; controller?.abort(); });
  const remove = handle => {
    const next = selected.find(p => p.handle !== handle);
    selected = selected.filter(p => p.handle !== handle); save(); message(''); sync();
    if (dialog.open) {
      if (selected.length < 2) close();
      else { render(); dialog.querySelector(`[data-nl4-remove="${next?.handle}"]`)?.focus({preventScroll:true}); }
    } else if (document.activeElement === document.body) returnFocus();
  };
  const aliases = {
    dimensions:['mitat','mått','dimensions','korkeus','höjd','height','leveys','bredd','width','pituus','längd','length','syvyys','djup','depth','halkaisija','diameter','läpimitta'],
    source:['valonlähde','ljuskälla','light source','lampunkanta','lamppukanta','kanta','sockel','socket','bulb base','integroitu led'],
    temperature:['värilämpötila','färgtemperatur','color temperature','colour temperature'],
    ip:['ip-luokitus','ip luokitus','ip-klass','ip class','ip rating','kotelointiluokka'],
    dimmable:['himmennettävyys','himmennettävä','dimbar','dimmable','dimming'],
    power:['teho','effekt','power','wattage','led-valonlähteen teho'],
    max_power:['led-lampun enimmäisteho','lampun enimmäisteho','enimmäisteho / valonlähde','maxeffekt','maximum bulb wattage'],
    lumens:['valovirta','ljusflöde','luminous flux','lumens']
  };
  const parse = (html,p) => {
    const doc = new DOMParser().parseFromString(html,'text/html');
    const data = doc.querySelector('[data-nl4-compare-product]');
    if (!data || data.dataset.handle !== p.handle) throw new Error('missing');
    const specs = {};
    data.querySelectorAll('[data-spec]').forEach(el => { if (el.textContent.trim()) specs[el.dataset.spec] = el.textContent.trim(); });
    const derived = {};
    data.querySelectorAll('[data-description] li,[data-description] tr').forEach(el => {
      let label,value;
      if (el.matches('tr') && el.children.length === 2) { label = el.children[0].textContent; value = el.children[1].textContent; }
      else { const parts = el.textContent.split(':'); if (parts.length < 2) return; label = parts.shift(); value = parts.join(':'); }
      label = label.trim(); value = value.trim();
      if (!value || value.length > 220) return;
      const normalized = label.toLocaleLowerCase().replace(/:$/,'').trim();
      const field = Object.keys(aliases).find(k => aliases[k].includes(normalized));
      if (!field || specs[field]) return;
      const line = field === 'dimensions' && !['mitat','mått','dimensions'].includes(normalized) || normalized === 'integroitu led' ? `${label}: ${value}` : value;
      (derived[field] ||= []).push({label:normalized,value,line});
    });
    for (const [field,values] of Object.entries(derived)) {
      const conflict = values.some(item => values.some(other => other.label === item.label && other.value !== item.value));
      specs[field] = conflict ? labels.varies : [...new Set(values.map(item => item.line))].join(' · ');
    }
    const url = productURL(p.handle).href;
    return {...p,title:data.dataset.title,url,image:data.dataset.image,vendor:data.dataset.vendor,price:data.dataset.price,availability:data.dataset.availability,multiple:data.dataset.multiple === 'true',specs};
  };
  const render = () => {
    const products = selected.map(p => records.find(r => r.handle === p.handle)).filter(Boolean);
    loading.hidden = !products.some(p => p.error);
    if (!loading.hidden) loading.textContent = root.dataset.error;
    const table = element('table',null,'nl4-compare-table'); table.dataset.count = products.length;
    const head = element('thead'); const headers = element('tr'); const blank = element('th',labels.product); blank.scope = 'col'; headers.append(blank);
    products.forEach(p => {
      const cell = element('th'); cell.scope = 'col';
      if (p.image) { const img = element('img',null,'nl4-compare-image'); img.src = p.image; img.alt = ''; img.width = 240; img.height = 160; cell.append(img); }
      const link = element('a',p.title,'nl4-compare-name'); link.href = productURL(p.handle).href; cell.append(link,element('span',p.vendor || '', 'nl4-compare-brand'));
      const button = element('button',root.dataset.remove,'nl4-compare-remove'); button.type = 'button'; button.dataset.nl4Remove = p.handle; button.setAttribute('aria-label',`${root.dataset.remove}: ${p.title}`); cell.append(button); headers.append(cell);
    });
    head.append(headers); table.append(head);
    const body = element('tbody');
    ['price','availability','dimensions','source','temperature','ip','dimmable','power','max_power','lumens'].forEach(field => {
      if (!['price','availability'].includes(field) && !products.some(p => p[field] || p.specs?.[field])) return;
      const row = element('tr'); const heading = element('th',labels[field]); heading.scope = 'row'; row.append(heading);
      products.forEach(p => { const value = p[field] || p.specs?.[field]; row.append(element('td',value || (p.error ? root.dataset.error : root.dataset.missing),value ? '' : 'nl4-compare-missing')); }); body.append(row);
    });
    const row = element('tr'); const heading = element('th',labels.view); heading.scope = 'row'; row.append(heading);
    products.forEach(p => { const cell = element('td'); const link = element('a',labels.view,'nl4-compare-view'); link.href = productURL(p.handle).href; cell.append(link); if (p.multiple) cell.append(element('p',labels.options,'nl4-compare-option-note')); row.append(cell); });
    body.append(row); table.append(body); tableHost.replaceChildren(table);
  };
  const open = async button => {
    if (selected.length < 2) return;
    opener = button; controller?.abort(); controller = new AbortController(); const current = ++revision;
    tableHost.replaceChildren(); loading.textContent = loadingLabel; loading.hidden = false; tableHost.setAttribute('aria-busy','true');
    if (!dialog.open) dialog.showModal();
    const products = [...selected];
    const results = await Promise.all(products.map(async p => {
      const url = productURL(p.handle); url.searchParams.set('section_id','nl4-compare-data');
      try { const response = await fetch(url,{signal:controller.signal}); if (response.status === 404) return {...p,missing:true}; if (!response.ok) throw new Error('load'); return parse(await response.text(),p); }
      catch (error) { return {...p,error:true,aborted:error.name === 'AbortError'}; }
    }));
    if (current !== revision || !dialog.open) return;
    records = results.filter(p => !p.missing);
    const missing = results.some(p => p.missing);
    if (missing) { selected = selected.filter(p => !results.some(r => r.handle === p.handle && r.missing)); save(); sync(); message(root.dataset.removed); }
    tableHost.setAttribute('aria-busy','false'); loading.hidden = true;
    if (selected.length < 2) { close(); return; }
    if (results.some(p => p.error)) { loading.textContent = root.dataset.error; loading.hidden = false; }
    render();
  };
  document.addEventListener('click',event => {
    const button = event.target.closest('[data-nl4-compare-handle]');
    if (!button) return;
    const handle = button.dataset.nl4CompareHandle;
    if (selected.some(p => p.handle === handle)) { remove(handle); return; }
    if (selected.length >= 3) { message(root.dataset.limit); root.querySelector('[data-nl4-selected] button')?.focus({preventScroll:true}); return; }
    selected.push({handle,title:button.dataset.nl4CompareTitle}); save(); message(''); sync();
  });
  root.addEventListener('click',event => {
    if (event.target.closest('[data-nl4-open]')) open(event.target.closest('button'));
    if (event.target.closest('[data-nl4-close]')) close();
    const removeButton = event.target.closest('[data-nl4-remove]'); if (removeButton) remove(removeButton.dataset.nl4Remove);
    if (event.target.closest('[data-nl4-clear]')) { const wasOpen = dialog.open; selected = []; save(); message(''); sync(); close(); if (!wasOpen) returnFocus(); }
    if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); }
  });
  window.addEventListener('storage',event => { if (event.key !== key) return; try { selected = valid(JSON.parse(event.newValue || '[]')); } catch (_) { selected = []; } sync(); if (dialog.open) selected.length >= 2 ? open(opener) : close(); });
  new MutationObserver(changes => { if (changes.some(change => [...change.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-nl4-compare-handle]') || node.querySelector('[data-nl4-compare-handle]'))))) syncButtons(); }).observe(document.querySelector('main') || document.body,{childList:true,subtree:true});
  let tick = false; const scheduleOffset = () => { if (tray.hidden || tick) return; tick = true; requestAnimationFrame(() => { offset(); tick = false; }); };
  window.addEventListener('scroll',scheduleOffset,{passive:true}); window.addEventListener('resize',scheduleOffset);
  const observer = new ResizeObserver(scheduleOffset); document.querySelectorAll('sticky-add-to-cart,#PBarNextFrame').forEach(el => observer.observe(el));
  sync();
})();

